unit SystemAutoMailSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.TMSWEBCustomComponent,
  WEBLib.TMSWEBStateManager, WEBLib.TMSWEBResponsiveManager, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Vcl.Controls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.Client, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.Buttons, WebLib.JSON, WEBLib.Grids, Vcl.Grids;

type
  TfrmAutoMailSetup = class(TForm)
    WebPanel2: TPanel;
    WebLabel6: TLabel;
    WebLabel8: TLabel;
    WebLabel7: TLabel;
    WebLabel3: TLabel;
    WebLabel5: TLabel;
    WebLabel4: TLabel;
    dblCompany: TDBLookupComboBox;
    dtReportDate: TDBDateTimePicker;
    dtLastReport: TDBDateTimePicker;
    dbePeriod: TDBEdit;
    cbNotifications: TDBCheckBox;
    cbEmail: TDBCheckBox;
    WebPanel1: TPanel;
    WebResponsiveManager1: TResponsiveManager;
    wdsAutoMail: TXDataWebDataSet;
    wcInfo: TXDataWebClient;
    dsAutoMail: TDataSource;
    wdsCompany: TXDataWebDataSet;
    wdsPeriodTypes: TXDataWebDataSet;
    dsCompany: TDataSource;
    dsReportingSystem: TDataSource;
    dsPeriodTypes: TDataSource;
    wdsAutoMailAutoMail_Auto: TIntegerField;
    wdsAutoMailSLnCode: TStringField;
    wdsAutoMailCompany: TStringField;
    WebBitBtn1: TBitBtn;
    wcCompanies: TXDataWebClient;
    wdsCompanySubCode: TStringField;
    wdsCompanySubName: TStringField;
    wdsCompanySuspended: TBooleanField;
    wdsCompanySubType: TIntegerField;
    wdsCompanyTypeName: TStringField;
    wcReportingSystem: TXDataWebClient;
    wcPeriodType: TXDataWebClient;
    wdsAutoMailReportSystem: TIntegerField;
    wdsAutoMailPeriodNo: TIntegerField;
    wdsAutoMailPeriodtype: TIntegerField;
    wdsAutoMailLastDate: TDateField;
    wdsAutoMailNextDate: TDateField;
    wdsAutoMailChangeDate: TDateField;
    wdsAutoMailUserNotice: TStringField;
    wdsAutoMailUserEmail: TStringField;
    wdsPeriodTypesDescription: TStringField;
    wdsReportingSystem: TXDataWebDataSet;
    wdsReportingSystemAutoNumber: TIntegerField;
    wdsPeriodTypesPeriodType_Auto: TIntegerField;
    wdsReportingSystemDescription: TStringField;
    dblReportSystem: TDBLookupComboBox;
    dblPeriodType: TDBLookupComboBox;
    btnCancel: TSpeedButton;
    procedure wdsAutoMailAfterOpen(DataSet: TDataSet);
    procedure wdsAutoMailNewRecord(DataSet: TDataSet);
    procedure WebBitBtn1Click(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
  private
    { Private declarations }

  public
    { Public declarations }
    iState,
    iPK : Integer;
    sSLNCode : String;
    procedure DoLoadData(iKey : Integer);
  protected procedure LoadDFMValues; override; end;

var
  frmAutoMailSetup: TfrmAutoMailSetup;

implementation

{$R *.dfm}

uses
  stfmsSystem.connection,
  share.system.classes,
  share.common;

procedure TfrmAutoMailSetup.btnCancelClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmAutoMailSetup.DoLoadData(iKey: Integer);
  procedure OnResult(Response : TXDataClientResponse);
  begin
    wdsAutoMail.Close;
    wdsAutoMail.SetJsonData(TJSObject(Response.Result));
    wdsAutoMail.Open;
  end;
  procedure OnResultComp3(Response : TXDataClientResponse);
  begin
    wdsPeriodTypes.Close;
    wdsPeriodTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsPeriodTypes.Open;
  end;
  procedure OnResultComp2(Response : TXDataClientResponse);
  begin
    wdsReportingSystem.Close;
    wdsReportingSystem.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsReportingSystem.Open;
  end;
  procedure OnResultComp(Response : TXDataClientResponse);
  begin
    wdsCompany.Close;
    wdsCompany.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsCompany.Open;
  end;
begin
  wcCompanies.RawInvoke('IstfmssearchService.GetSubs', [True, -1], @OnResultComp);
  wcInfo.RawInvoke('IstfmsSystemService.Get_AutoEmail_PK', [iKey], @OnResult);
  wcPeriodType.RawInvoke('IstfmsSystemService.Get_PeriodType',[],@OnResultComp3);
  wcReportingSystem.RawInvoke('IstfmsSystemService.Get_AutoMailReportingSystem',[], @OnResultComp2);
end;

procedure TfrmAutoMailSetup.wdsAutoMailAfterOpen(DataSet: TDataSet);
begin
  Case iState of
    1 : wdsAutoMail.Append;
    2 : wdsAutoMail.Edit;
  End;
end;

procedure TfrmAutoMailSetup.wdsAutoMailNewRecord(DataSet: TDataSet);
begin
  wdsAutoMail.FieldByName('SLNCode').asString := sSLNCode;
end;

procedure TfrmAutoMailSetup.WebBitBtn1Click(Sender: TObject);
  var

    wslSysAutoMailInsert : WideString;
    wslSysAutoEmailEdit : WideString;

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    wdsAutoMail.Cancel;
    Close;
  end;
  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage(Error.ErrorMessage);
  end;
begin
  Case iState of
    1 : begin
          wcInfo.RawInvoke('IstfmsSystemService.Put_AutoEmail_Insert', [GetJsonFromDataSet(wdsAutoMail)],@OnSuccess, @OnError);      //////////
        end;
    2 : begin
          wcInfo.RawInvoke('IstfmsSystemService.Put_AutoEmail_Edit', [GetJsonFromDataSet(wdsAutoMail)],@OnSuccess, @OnError);          /////////
        end;

  end;
end;

procedure TfrmAutoMailSetup.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := caFree;
end;

procedure TfrmAutoMailSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel2 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  dblCompany := TDBLookupComboBox.Create(Self);
  dtReportDate := TDBDateTimePicker.Create(Self);
  dtLastReport := TDBDateTimePicker.Create(Self);
  dbePeriod := TDBEdit.Create(Self);
  cbNotifications := TDBCheckBox.Create(Self);
  cbEmail := TDBCheckBox.Create(Self);
  WebBitBtn1 := TBitBtn.Create(Self);
  dblReportSystem := TDBLookupComboBox.Create(Self);
  dblPeriodType := TDBLookupComboBox.Create(Self);
  btnCancel := TSpeedButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebResponsiveManager1 := TResponsiveManager.Create(Self);
  wdsAutoMail := TXDataWebDataSet.Create(Self);
  wdsAutoMailAutoMail_Auto := TIntegerField.Create(Self);
  wdsAutoMailSLnCode := TStringField.Create(Self);
  wdsAutoMailCompany := TStringField.Create(Self);
  wdsAutoMailReportSystem := TIntegerField.Create(Self);
  wdsAutoMailPeriodNo := TIntegerField.Create(Self);
  wdsAutoMailPeriodtype := TIntegerField.Create(Self);
  wdsAutoMailLastDate := TDateField.Create(Self);
  wdsAutoMailNextDate := TDateField.Create(Self);
  wdsAutoMailChangeDate := TDateField.Create(Self);
  wdsAutoMailUserNotice := TStringField.Create(Self);
  wdsAutoMailUserEmail := TStringField.Create(Self);
  wcInfo := TXDataWebClient.Create(Self);
  dsAutoMail := TDataSource.Create(Self);
  wdsCompany := TXDataWebDataSet.Create(Self);
  wdsCompanySubCode := TStringField.Create(Self);
  wdsCompanySubName := TStringField.Create(Self);
  wdsCompanySuspended := TBooleanField.Create(Self);
  wdsCompanySubType := TIntegerField.Create(Self);
  wdsCompanyTypeName := TStringField.Create(Self);
  wdsPeriodTypes := TXDataWebDataSet.Create(Self);
  wdsPeriodTypesDescription := TStringField.Create(Self);
  wdsPeriodTypesPeriodType_Auto := TIntegerField.Create(Self);
  dsCompany := TDataSource.Create(Self);
  dsReportingSystem := TDataSource.Create(Self);
  dsPeriodTypes := TDataSource.Create(Self);
  wcCompanies := TXDataWebClient.Create(Self);
  wcReportingSystem := TXDataWebClient.Create(Self);
  wcPeriodType := TXDataWebClient.Create(Self);
  wdsReportingSystem := TXDataWebDataSet.Create(Self);
  wdsReportingSystemAutoNumber := TIntegerField.Create(Self);
  wdsReportingSystemDescription := TStringField.Create(Self);

  WebPanel2.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  dblCompany.BeforeLoadDFMValues;
  dtReportDate.BeforeLoadDFMValues;
  dtLastReport.BeforeLoadDFMValues;
  dbePeriod.BeforeLoadDFMValues;
  cbNotifications.BeforeLoadDFMValues;
  cbEmail.BeforeLoadDFMValues;
  WebBitBtn1.BeforeLoadDFMValues;
  dblReportSystem.BeforeLoadDFMValues;
  dblPeriodType.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebResponsiveManager1.BeforeLoadDFMValues;
  wdsAutoMail.BeforeLoadDFMValues;
  wdsAutoMailAutoMail_Auto.BeforeLoadDFMValues;
  wdsAutoMailSLnCode.BeforeLoadDFMValues;
  wdsAutoMailCompany.BeforeLoadDFMValues;
  wdsAutoMailReportSystem.BeforeLoadDFMValues;
  wdsAutoMailPeriodNo.BeforeLoadDFMValues;
  wdsAutoMailPeriodtype.BeforeLoadDFMValues;
  wdsAutoMailLastDate.BeforeLoadDFMValues;
  wdsAutoMailNextDate.BeforeLoadDFMValues;
  wdsAutoMailChangeDate.BeforeLoadDFMValues;
  wdsAutoMailUserNotice.BeforeLoadDFMValues;
  wdsAutoMailUserEmail.BeforeLoadDFMValues;
  wcInfo.BeforeLoadDFMValues;
  dsAutoMail.BeforeLoadDFMValues;
  wdsCompany.BeforeLoadDFMValues;
  wdsCompanySubCode.BeforeLoadDFMValues;
  wdsCompanySubName.BeforeLoadDFMValues;
  wdsCompanySuspended.BeforeLoadDFMValues;
  wdsCompanySubType.BeforeLoadDFMValues;
  wdsCompanyTypeName.BeforeLoadDFMValues;
  wdsPeriodTypes.BeforeLoadDFMValues;
  wdsPeriodTypesDescription.BeforeLoadDFMValues;
  wdsPeriodTypesPeriodType_Auto.BeforeLoadDFMValues;
  dsCompany.BeforeLoadDFMValues;
  dsReportingSystem.BeforeLoadDFMValues;
  dsPeriodTypes.BeforeLoadDFMValues;
  wcCompanies.BeforeLoadDFMValues;
  wcReportingSystem.BeforeLoadDFMValues;
  wcPeriodType.BeforeLoadDFMValues;
  wdsReportingSystem.BeforeLoadDFMValues;
  wdsReportingSystemAutoNumber.BeforeLoadDFMValues;
  wdsReportingSystemDescription.BeforeLoadDFMValues;
  try
    Name := 'frmAutoMailSetup';
    Width := 807;
    Height := 428;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 49;
    WebPanel2.Width := 807;
    WebPanel2.Height := 379;
    WebPanel2.Align := alClient;
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -18;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 96;
    WebLabel6.Top := 60;
    WebLabel6.Width := 63;
    WebLabel6.Height := 20;
    WebLabel6.Caption := 'Company';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -15;
    WebLabel6.Font.Name := 'Segoe UI';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel2);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 416;
    WebLabel8.Top := 130;
    WebLabel8.Width := 116;
    WebLabel8.Height := 20;
    WebLabel8.Caption := 'Next Report Date';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -15;
    WebLabel8.Font.Name := 'Segoe UI';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel2);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 576;
    WebLabel7.Top := 130;
    WebLabel7.Width := 109;
    WebLabel7.Height := 20;
    WebLabel7.Caption := 'Last Report date';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -15;
    WebLabel7.Font.Name := 'Segoe UI';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 418;
    WebLabel3.Top := 60;
    WebLabel3.Width := 117;
    WebLabel3.Height := 20;
    WebLabel3.Caption := 'Reporting System';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -15;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 240;
    WebLabel5.Top := 130;
    WebLabel5.Width := 77;
    WebLabel5.Height := 20;
    WebLabel5.Caption := 'Period Type';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -15;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 96;
    WebLabel4.Top := 130;
    WebLabel4.Width := 42;
    WebLabel4.Height := 20;
    WebLabel4.Caption := 'Period';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -15;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    dblCompany.SetParentComponent(WebPanel2);
    dblCompany.Name := 'dblCompany';
    dblCompany.Left := 96;
    dblCompany.Top := 86;
    dblCompany.Width := 273;
    dblCompany.Height := 22;
    dblCompany.Color := clWhite;
    dblCompany.Font.Charset := DEFAULT_CHARSET;
    dblCompany.Font.Color := clWindowText;
    dblCompany.Font.Height := -15;
    dblCompany.Font.Name := 'Segoe UI';
    dblCompany.Font.Style := [];
    dblCompany.HeightPercent := 100.000000000000000000;
    dblCompany.ParentFont := False;
    dblCompany.WidthPercent := 100.000000000000000000;
    dblCompany.DataField := 'Company';
    dblCompany.DataSource := dsAutoMail;
    dblCompany.KeyField := 'SubCode';
    dblCompany.ListField := 'SubName';
    dblCompany.ListSource := dsCompany;
    dtReportDate.SetParentComponent(WebPanel2);
    dtReportDate.Name := 'dtReportDate';
    dtReportDate.Left := 416;
    dtReportDate.Top := 156;
    dtReportDate.Width := 121;
    dtReportDate.Height := 21;
    dtReportDate.BorderStyle := bsSingle;
    dtReportDate.ChildOrder := 13;
    dtReportDate.Color := clWhite;
    dtReportDate.Date := 45643.600752083300000000;
    dtReportDate.Font.Charset := DEFAULT_CHARSET;
    dtReportDate.Font.Color := clWindowText;
    dtReportDate.Font.Height := -15;
    dtReportDate.Font.Name := 'Segoe UI';
    dtReportDate.Font.Style := [];
    dtReportDate.ParentFont := False;
    dtReportDate.Role := '';
    dtReportDate.Text := '';
    dtReportDate.DataField := 'NEXTDATE';
    dtReportDate.DataSource := dsAutoMail;
    dtLastReport.SetParentComponent(WebPanel2);
    dtLastReport.Name := 'dtLastReport';
    dtLastReport.Left := 566;
    dtLastReport.Top := 156;
    dtLastReport.Width := 121;
    dtLastReport.Height := 22;
    dtLastReport.BorderStyle := bsSingle;
    dtLastReport.ChildOrder := 13;
    dtLastReport.Color := clWhite;
    dtLastReport.Date := 45643.600838842600000000;
    dtLastReport.Font.Charset := DEFAULT_CHARSET;
    dtLastReport.Font.Color := clWindowText;
    dtLastReport.Font.Height := -15;
    dtLastReport.Font.Name := 'Segoe UI';
    dtLastReport.Font.Style := [];
    dtLastReport.ParentFont := False;
    dtLastReport.Role := '';
    dtLastReport.Text := '';
    dtLastReport.DataField := 'LASTDATE';
    dtLastReport.DataSource := dsAutoMail;
    dbePeriod.SetParentComponent(WebPanel2);
    dbePeriod.Name := 'dbePeriod';
    dbePeriod.Left := 96;
    dbePeriod.Top := 156;
    dbePeriod.Width := 122;
    dbePeriod.Height := 22;
    dbePeriod.ChildOrder := 13;
    dbePeriod.Color := clWhite;
    dbePeriod.Font.Charset := DEFAULT_CHARSET;
    dbePeriod.Font.Color := clWindowText;
    dbePeriod.Font.Height := -15;
    dbePeriod.Font.Name := 'Segoe UI';
    dbePeriod.Font.Style := [];
    dbePeriod.HeightPercent := 100.000000000000000000;
    dbePeriod.ParentFont := False;
    dbePeriod.Text := 'dbePeriod';
    dbePeriod.WidthPercent := 100.000000000000000000;
    dbePeriod.DataField := 'PERIODNO';
    dbePeriod.DataSource := dsAutoMail;
    cbNotifications.SetParentComponent(WebPanel2);
    cbNotifications.Name := 'cbNotifications';
    cbNotifications.Left := 553;
    cbNotifications.Top := 213;
    cbNotifications.Width := 168;
    cbNotifications.Height := 22;
    cbNotifications.Caption := 'User Notification';
    cbNotifications.ChildOrder := 13;
    cbNotifications.Color := clSilver;
    cbNotifications.Font.Charset := DEFAULT_CHARSET;
    cbNotifications.Font.Color := clWindowText;
    cbNotifications.Font.Height := -15;
    cbNotifications.Font.Name := 'Segoe UI';
    cbNotifications.Font.Style := [];
    cbNotifications.HeightPercent := 100.000000000000000000;
    cbNotifications.ParentFont := False;
    cbNotifications.WidthPercent := 100.000000000000000000;
    cbNotifications.DataField := 'USERNOTICE';
    cbNotifications.DataSource := dsAutoMail;
    cbNotifications.ValueChecked := 'Y';
    cbNotifications.ValueUnChecked := 'N';
    cbEmail.SetParentComponent(WebPanel2);
    cbEmail.Name := 'cbEmail';
    cbEmail.Left := 162;
    cbEmail.Top := 213;
    cbEmail.Width := 135;
    cbEmail.Height := 22;
    cbEmail.Caption := 'Email Reports';
    cbEmail.ChildOrder := 13;
    cbEmail.Color := clSilver;
    cbEmail.Font.Charset := DEFAULT_CHARSET;
    cbEmail.Font.Color := clWindowText;
    cbEmail.Font.Height := -15;
    cbEmail.Font.Name := 'Segoe UI';
    cbEmail.Font.Style := [];
    cbEmail.HeightPercent := 100.000000000000000000;
    cbEmail.ParentFont := False;
    cbEmail.WidthPercent := 100.000000000000000000;
    cbEmail.DataField := 'USEREMAIL';
    cbEmail.DataSource := dsAutoMail;
    cbEmail.ValueChecked := 'Y';
    cbEmail.ValueUnChecked := 'N';
    WebBitBtn1.SetParentComponent(WebPanel2);
    WebBitBtn1.Name := 'WebBitBtn1';
    WebBitBtn1.Left := 96;
    WebBitBtn1.Top := 256;
    WebBitBtn1.Width := 80;
    WebBitBtn1.Height := 25;
    WebBitBtn1.Caption := 'Save';
    WebBitBtn1.Color := clNone;
    WebBitBtn1.Font.Charset := DEFAULT_CHARSET;
    WebBitBtn1.Font.Color := clWindowText;
    WebBitBtn1.Font.Height := -15;
    WebBitBtn1.Font.Name := 'Segoe UI';
    WebBitBtn1.Font.Style := [];
    WebBitBtn1.HeightPercent := 100.000000000000000000;
    WebBitBtn1.ParentFont := False;
    WebBitBtn1.WidthPercent := 100.000000000000000000;
    SetEvent(WebBitBtn1, Self, 'OnClick', 'WebBitBtn1Click');
    dblReportSystem.SetParentComponent(WebPanel2);
    dblReportSystem.Name := 'dblReportSystem';
    dblReportSystem.Left := 418;
    dblReportSystem.Top := 86;
    dblReportSystem.Width := 269;
    dblReportSystem.Height := 22;
    dblReportSystem.Font.Charset := DEFAULT_CHARSET;
    dblReportSystem.Font.Color := clWindowText;
    dblReportSystem.Font.Height := -15;
    dblReportSystem.Font.Name := 'Segoe UI';
    dblReportSystem.Font.Style := [];
    dblReportSystem.HeightPercent := 100.000000000000000000;
    dblReportSystem.ParentFont := False;
    dblReportSystem.WidthPercent := 100.000000000000000000;
    dblReportSystem.DataField := 'ReportSystem';
    dblReportSystem.DataSource := dsAutoMail;
    dblReportSystem.KeyField := 'AutoNumber';
    dblReportSystem.ListField := 'Description';
    dblReportSystem.ListSource := dsReportingSystem;
    dblPeriodType.SetParentComponent(WebPanel2);
    dblPeriodType.Name := 'dblPeriodType';
    dblPeriodType.Left := 240;
    dblPeriodType.Top := 156;
    dblPeriodType.Width := 105;
    dblPeriodType.Height := 22;
    dblPeriodType.Font.Charset := DEFAULT_CHARSET;
    dblPeriodType.Font.Color := clWindowText;
    dblPeriodType.Font.Height := -15;
    dblPeriodType.Font.Name := 'Segoe UI';
    dblPeriodType.Font.Style := [];
    dblPeriodType.HeightPercent := 100.000000000000000000;
    dblPeriodType.ParentFont := False;
    dblPeriodType.WidthPercent := 100.000000000000000000;
    dblPeriodType.DataField := 'Periodtype';
    dblPeriodType.DataSource := dsAutoMail;
    dblPeriodType.KeyField := 'PeriodType_Auto';
    dblPeriodType.ListField := 'Description';
    dblPeriodType.ListSource := dsPeriodTypes;
    btnCancel.SetParentComponent(WebPanel2);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 194;
    btnCancel.Top := 257;
    btnCancel.Width := 24;
    btnCancel.Height := 24;
    btnCancel.Caption := 'btnCancel';
    btnCancel.Color := clNone;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.TabOrder := 9;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 807;
    WebPanel1.Height := 49;
    WebPanel1.Align := alTop;
    WebPanel1.Caption := 'Auto E-Mail Setup';
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := clSilver;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -17;
    WebPanel1.Font.Name := 'Segoe UI';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 1;
    WebResponsiveManager1.SetParentComponent(WebPanel1);
    WebResponsiveManager1.Name := 'WebResponsiveManager1';
    WebResponsiveManager1.Left := 16;
    WebResponsiveManager1.Top := 16;
    WebResponsiveManager1.Width := 26;
    WebResponsiveManager1.Height := 26;
    WebResponsiveManager1.Visible := True;
    WebResponsiveManager1.Control := Self;
    wdsAutoMail.SetParentComponent(Self);
    wdsAutoMail.Name := 'wdsAutoMail';
    wdsAutoMail.AfterOpen := wdsAutoMailAfterOpen;
    SetEvent(wdsAutoMail, Self, 'OnNewRecord', 'wdsAutoMailNewRecord');
    wdsAutoMail.Connection := dmData.dbConnect;
    wdsAutoMail.Left := 440;
    wdsAutoMail.Top := 329;
    wdsAutoMailAutoMail_Auto.SetParentComponent(wdsAutoMail);
    wdsAutoMailAutoMail_Auto.Name := 'wdsAutoMailAutoMail_Auto';
    wdsAutoMailAutoMail_Auto.FieldName := 'AutoMail_Auto';
    wdsAutoMailSLnCode.SetParentComponent(wdsAutoMail);
    wdsAutoMailSLnCode.Name := 'wdsAutoMailSLnCode';
    wdsAutoMailSLnCode.FieldName := 'SLnCode';
    wdsAutoMailCompany.SetParentComponent(wdsAutoMail);
    wdsAutoMailCompany.Name := 'wdsAutoMailCompany';
    wdsAutoMailCompany.FieldName := 'Company';
    wdsAutoMailReportSystem.SetParentComponent(wdsAutoMail);
    wdsAutoMailReportSystem.Name := 'wdsAutoMailReportSystem';
    wdsAutoMailReportSystem.FieldName := 'ReportSystem';
    wdsAutoMailPeriodNo.SetParentComponent(wdsAutoMail);
    wdsAutoMailPeriodNo.Name := 'wdsAutoMailPeriodNo';
    wdsAutoMailPeriodNo.FieldName := 'PeriodNo';
    wdsAutoMailPeriodtype.SetParentComponent(wdsAutoMail);
    wdsAutoMailPeriodtype.Name := 'wdsAutoMailPeriodtype';
    wdsAutoMailPeriodtype.FieldName := 'Periodtype';
    wdsAutoMailLastDate.SetParentComponent(wdsAutoMail);
    wdsAutoMailLastDate.Name := 'wdsAutoMailLastDate';
    wdsAutoMailLastDate.FieldName := 'LastDate';
    wdsAutoMailNextDate.SetParentComponent(wdsAutoMail);
    wdsAutoMailNextDate.Name := 'wdsAutoMailNextDate';
    wdsAutoMailNextDate.FieldName := 'NextDate';
    wdsAutoMailChangeDate.SetParentComponent(wdsAutoMail);
    wdsAutoMailChangeDate.Name := 'wdsAutoMailChangeDate';
    wdsAutoMailChangeDate.FieldName := 'ChangeDate';
    wdsAutoMailUserNotice.SetParentComponent(wdsAutoMail);
    wdsAutoMailUserNotice.Name := 'wdsAutoMailUserNotice';
    wdsAutoMailUserNotice.FieldName := 'UserNotice';
    wdsAutoMailUserEmail.SetParentComponent(wdsAutoMail);
    wdsAutoMailUserEmail.Name := 'wdsAutoMailUserEmail';
    wdsAutoMailUserEmail.FieldName := 'UserEmail';
    wcInfo.SetParentComponent(Self);
    wcInfo.Name := 'wcInfo';
    wcInfo.Connection := dmData.dbConnect;
    wcInfo.Left := 544;
    wcInfo.Top := 345;
    dsAutoMail.SetParentComponent(Self);
    dsAutoMail.Name := 'dsAutoMail';
    dsAutoMail.AutoEdit := False;
    dsAutoMail.DataSet := wdsAutoMail;
    dsAutoMail.Left := 440;
    dsAutoMail.Top := 377;
    wdsCompany.SetParentComponent(Self);
    wdsCompany.Name := 'wdsCompany';
    wdsCompany.Connection := dmData.dbConnect;
    wdsCompany.Left := 224;
    wdsCompany.Top := 105;
    wdsCompanySubCode.SetParentComponent(wdsCompany);
    wdsCompanySubCode.Name := 'wdsCompanySubCode';
    wdsCompanySubCode.FieldName := 'SubCode';
    wdsCompanySubName.SetParentComponent(wdsCompany);
    wdsCompanySubName.Name := 'wdsCompanySubName';
    wdsCompanySubName.FieldName := 'SubName';
    wdsCompanySuspended.SetParentComponent(wdsCompany);
    wdsCompanySuspended.Name := 'wdsCompanySuspended';
    wdsCompanySuspended.FieldName := 'Suspended';
    wdsCompanySubType.SetParentComponent(wdsCompany);
    wdsCompanySubType.Name := 'wdsCompanySubType';
    wdsCompanySubType.FieldName := 'SubType';
    wdsCompanyTypeName.SetParentComponent(wdsCompany);
    wdsCompanyTypeName.Name := 'wdsCompanyTypeName';
    wdsCompanyTypeName.FieldName := 'TypeName';
    wdsPeriodTypes.SetParentComponent(Self);
    wdsPeriodTypes.Name := 'wdsPeriodTypes';
    wdsPeriodTypes.Connection := dmData.dbConnect;
    wdsPeriodTypes.Left := 272;
    wdsPeriodTypes.Top := 321;
    wdsPeriodTypesDescription.SetParentComponent(wdsPeriodTypes);
    wdsPeriodTypesDescription.Name := 'wdsPeriodTypesDescription';
    wdsPeriodTypesDescription.FieldName := 'Description';
    wdsPeriodTypesPeriodType_Auto.SetParentComponent(wdsPeriodTypes);
    wdsPeriodTypesPeriodType_Auto.Name := 'wdsPeriodTypesPeriodType_Auto';
    wdsPeriodTypesPeriodType_Auto.FieldName := 'PeriodType_Auto';
    dsCompany.SetParentComponent(Self);
    dsCompany.Name := 'dsCompany';
    dsCompany.AutoEdit := False;
    dsCompany.DataSet := wdsCompany;
    dsCompany.Left := 288;
    dsCompany.Top := 113;
    dsReportingSystem.SetParentComponent(Self);
    dsReportingSystem.Name := 'dsReportingSystem';
    dsReportingSystem.AutoEdit := False;
    dsReportingSystem.DataSet := wdsReportingSystem;
    dsReportingSystem.Left := 632;
    dsReportingSystem.Top := 105;
    dsPeriodTypes.SetParentComponent(Self);
    dsPeriodTypes.Name := 'dsPeriodTypes';
    dsPeriodTypes.AutoEdit := False;
    dsPeriodTypes.DataSet := wdsPeriodTypes;
    dsPeriodTypes.Left := 384;
    dsPeriodTypes.Top := 257;
    wcCompanies.SetParentComponent(Self);
    wcCompanies.Name := 'wcCompanies';
    wcCompanies.Connection := dmData.dbConnect;
    wcCompanies.Left := 120;
    wcCompanies.Top := 121;
    wcReportingSystem.SetParentComponent(Self);
    wcReportingSystem.Name := 'wcReportingSystem';
    wcReportingSystem.Connection := dmData.dbConnect;
    wcReportingSystem.Left := 424;
    wcReportingSystem.Top := 81;
    wcPeriodType.SetParentComponent(Self);
    wcPeriodType.Name := 'wcPeriodType';
    wcPeriodType.Connection := dmData.dbConnect;
    wcPeriodType.Left := 248;
    wcPeriodType.Top := 217;
    wdsReportingSystem.SetParentComponent(Self);
    wdsReportingSystem.Name := 'wdsReportingSystem';
    wdsReportingSystem.Connection := dmData.dbConnect;
    wdsReportingSystem.Left := 536;
    wdsReportingSystem.Top := 97;
    wdsReportingSystemAutoNumber.SetParentComponent(wdsReportingSystem);
    wdsReportingSystemAutoNumber.Name := 'wdsReportingSystemAutoNumber';
    wdsReportingSystemAutoNumber.FieldName := 'AutoNumber';
    wdsReportingSystemDescription.SetParentComponent(wdsReportingSystem);
    wdsReportingSystemDescription.Name := 'wdsReportingSystemDescription';
    wdsReportingSystemDescription.FieldName := 'Description';
  finally
    WebPanel2.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    dblCompany.AfterLoadDFMValues;
    dtReportDate.AfterLoadDFMValues;
    dtLastReport.AfterLoadDFMValues;
    dbePeriod.AfterLoadDFMValues;
    cbNotifications.AfterLoadDFMValues;
    cbEmail.AfterLoadDFMValues;
    WebBitBtn1.AfterLoadDFMValues;
    dblReportSystem.AfterLoadDFMValues;
    dblPeriodType.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebResponsiveManager1.AfterLoadDFMValues;
    wdsAutoMail.AfterLoadDFMValues;
    wdsAutoMailAutoMail_Auto.AfterLoadDFMValues;
    wdsAutoMailSLnCode.AfterLoadDFMValues;
    wdsAutoMailCompany.AfterLoadDFMValues;
    wdsAutoMailReportSystem.AfterLoadDFMValues;
    wdsAutoMailPeriodNo.AfterLoadDFMValues;
    wdsAutoMailPeriodtype.AfterLoadDFMValues;
    wdsAutoMailLastDate.AfterLoadDFMValues;
    wdsAutoMailNextDate.AfterLoadDFMValues;
    wdsAutoMailChangeDate.AfterLoadDFMValues;
    wdsAutoMailUserNotice.AfterLoadDFMValues;
    wdsAutoMailUserEmail.AfterLoadDFMValues;
    wcInfo.AfterLoadDFMValues;
    dsAutoMail.AfterLoadDFMValues;
    wdsCompany.AfterLoadDFMValues;
    wdsCompanySubCode.AfterLoadDFMValues;
    wdsCompanySubName.AfterLoadDFMValues;
    wdsCompanySuspended.AfterLoadDFMValues;
    wdsCompanySubType.AfterLoadDFMValues;
    wdsCompanyTypeName.AfterLoadDFMValues;
    wdsPeriodTypes.AfterLoadDFMValues;
    wdsPeriodTypesDescription.AfterLoadDFMValues;
    wdsPeriodTypesPeriodType_Auto.AfterLoadDFMValues;
    dsCompany.AfterLoadDFMValues;
    dsReportingSystem.AfterLoadDFMValues;
    dsPeriodTypes.AfterLoadDFMValues;
    wcCompanies.AfterLoadDFMValues;
    wcReportingSystem.AfterLoadDFMValues;
    wcPeriodType.AfterLoadDFMValues;
    wdsReportingSystem.AfterLoadDFMValues;
    wdsReportingSystemAutoNumber.AfterLoadDFMValues;
    wdsReportingSystemDescription.AfterLoadDFMValues;
  end;
end;

end.
